import React, { useRef, useState } from "react"
import styled from "styled-components/macro"
import Colors from "../../consts/Colors"
import Button from "../button/Button"
import Utils from "../../consts/Utlis"
import Devices from "../../consts/Devices"

const EnterSection = ({ openModal }) => {
  return (
    <>
      <Wrapper>
        <Price>£330</Price>
        <CTA>ENTER BALLOT</CTA>
        <Blurb>Draw closes on 06/11/2019 @ Midnight.</Blurb>
        <ButtonComp onClick={openModal}>
          <span>Enter Ballot</span>
        </ButtonComp>
      </Wrapper>
      <Link>
        <a href="https://neu.studio" target="_blank">
          neu
        </a>
        <div
          style={{
            position: "relative",
            zIndex: 1000000,
          }}
          onClick={() => {
            if (typeof window !== `undefined`) {
              window.localStorage.clear()
              window.location.reload()
            }
          }}
        >
          .
        </div>
      </Link>
    </>
  )
}

const Link = styled.div`
  text-align: center;
  padding-bottom: 10px;
  a {
    color: rgba(23, 23, 23, 0.3);
  }
`

const Wrapper = styled.div`
  min-height: 500px;
  background: #171717;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 5rem 0;
  height: 50vh;
  @media ${Devices.laptop} {
    margin-bottom: 10px;
    border-radius: 0 0 5px 5px;
  }
`

const Price = styled.h3`
  ${Utils.fontSize(18, 33, "1200px")}
  color: #ffffff;
  text-align: center;
  font-family: "Nanum Myeongjo", serif;
`
const CTA = styled.h2`
  ${Utils.fontSize(22, 80, "1200px")}
  color: #ffffff;
  text-align: center;
  font-family: "Nanum Myeongjo", serif;
`
const Blurb = styled.div`
  ${Utils.fontSize(16, 18, "1200px")}
  color: #ffffff;
  text-align: center;
  font-family: "Work Sans", sans-serif;
  padding: 0 1rem;
  max-width: 500px;
  margin: 0 auto;
  font-weight: 300;
`
const ButtonComp = styled(Button)`
  margin-top: 3rem;
`

export default EnterSection
